import { FC, useCallback, MouseEvent } from 'react';
import { useSelector } from 'react-redux';
import { Checkbox } from '@getsynapse/design-system';
import { RootState, useAppThunkDispatch } from 'state/store';
import {
  toggleSelectedProject,
  selectIsProjectSelected,
} from 'state/ProjectsList/export/exportSlice';

interface SelectProjectProps {
  projectId: string;
  className?: string;
}

const SelectProject: FC<SelectProjectProps> = ({ projectId, className }) => {
  const dispatch = useAppThunkDispatch();
  const isProjectSelected = useSelector((state: RootState) =>
    selectIsProjectSelected(state, projectId)
  );

  const handleSelectProject = useCallback(() => {
    dispatch(toggleSelectedProject(projectId));
  }, [dispatch, projectId]);

  return (
    <div
      className={className}
      onClick={(event: MouseEvent<HTMLDivElement>) => event.stopPropagation()}
    >
      <Checkbox
        checked={isProjectSelected}
        onChange={handleSelectProject}
        inputProps={{
          'aria-label': `select-project-${projectId}-checkbox`,
        }}
        label=''
      />
    </div>
  );
};

export default SelectProject;
